var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconArrowRoundBack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.166,
    height: 11.449,
    viewBox: "0 0 17.166 11.449",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-round-back",
    "data-name": "Icon ionic-ios-arrow-round-back",
    d: "M14.1,11.471a.779.779,0,0,1,.006,1.1L10.488,16.2H24.278a.775.775,0,0,1,0,1.55H10.488l3.625,3.631a.785.785,0,0,1-.006,1.1.772.772,0,0,1-1.091-.006L8.1,17.523h0a.87.87,0,0,1-.161-.244.74.74,0,0,1-.06-.3.777.777,0,0,1,.221-.543l4.913-4.949A.76.76,0,0,1,14.1,11.471Z",
    transform: "translate(-7.882 -11.252)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconArrowRoundBack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-arrow-round-back.bce3a7e4.svg";
export { ForwardRef as ReactComponent };